import { Theme, useTheme } from "@mui/material/styles";;

// Define SupportedMethods type as filter type of methods axios use case.
export enum SupportedMethods {
    get = "get",
    post = "post",
    put = "put",
    delete = "delete",
    patch = "patch"
};
const baseUrlAzmon = "https://azmoonproxy.niktech.org/server"
const baseUrlPdfGenHomzhans = "https://pdfgen.homzhans.com/api/"
// const baseUrlGolangHomzhans = "http://127.0.0.1:1323/"
const baseUrlGolangHomzhans = "https://testextraction.homzhans.com/"
export enum EnumServerSelected {
    azmoon = 0,
    pdfGenHomzhans = 1,
    goLangHomzhans = 2
}
// Put your new endpoint like here.
export const HandlerLangUrl = (url: string, mtheme: any, serverSelected: EnumServerSelected) => {
    if (serverSelected == EnumServerSelected.azmoon) {
        return (`${baseUrlAzmon}${url}`)
    }

    else if(serverSelected == EnumServerSelected.pdfGenHomzhans) {
        return (`${baseUrlPdfGenHomzhans}${url}`)
    }
    else {
        return (`${baseUrlGolangHomzhans}${url}`)
    }
}

export const urlsListAzmoon = {

    login: { url: `/ReceptionResult`, method: SupportedMethods.get, isTokenNecessary: false, isFileInclude: false },
    loginGroup: { url: `/ReceptionResultLab.aspx`, method: SupportedMethods.get, isTokenNecessary: false, isFileInclude: false },
};
export const urlsListPdfGenHomzhans = {
    postCreatePDF: { url: `pdf-gen-for-front/`, method: SupportedMethods.post, isTokenNecessary: false, isFileInclude: false },
    getPDFSigned: { url: `pdf-airline/`, method: SupportedMethods.get, isTokenNecessary: false, isFileInclude: false },
};
export const urlsGoLang = {
    getAllKindOfTest: { url: `getAllKindTest/`, method: SupportedMethods.get, isTokenNecessary: false, isFileInclude: false },
};